/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyProfileActionEnum = 'RequestActivation' | 'Activate' | 'RequestDeactivation' | 'Deactivate' | 'Extend' | 'Expire' | 'Update';

export const CompanyProfileActionEnum = {
    RequestActivation: 'RequestActivation' as CompanyProfileActionEnum,
    Activate: 'Activate' as CompanyProfileActionEnum,
    RequestDeactivation: 'RequestDeactivation' as CompanyProfileActionEnum,
    Deactivate: 'Deactivate' as CompanyProfileActionEnum,
    Extend: 'Extend' as CompanyProfileActionEnum,
    Expire: 'Expire' as CompanyProfileActionEnum,
    Update: 'Update' as CompanyProfileActionEnum
};

